module.exports = __webpack_public_path__ + "img/new-document.c741bd3b.png";